module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAgElEQVRYhe2WwQnAMAhFM0yTgQLOU0L3rtVDIBTbXqrJ4T/wqk8wxpTADWYuElWCfg7NWb6KHxIn+6G521vnnsVHiWwJ1IDinWoJUKAAQWBJgelDGPkMt6dd0JwlNPduFh8kMvutYrtzAEYY94A/uAeUNX9DCEwfQtwDXQL3QCgXl5C6PIs+MEsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/mosaic.png
// module id = mOVb
// module chunks = 2